export const PENDING_STATUS = 'Pending';
export const GOOGLE_API_KEY = 'AIzaSyDW22og-eWTjhN4itI5aanVnfksxnXPQaE';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  PENDING_STATUS,
  GOOGLE_API_KEY,
};
